import { render, staticRenderFns } from "./SourceCard.vue?vue&type=template&id=4438bec0&scoped=true&"
import script from "./SourceCard.vue?vue&type=script&lang=js&"
export * from "./SourceCard.vue?vue&type=script&lang=js&"
import style0 from "./SourceCard.vue?vue&type=style&index=0&id=4438bec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438bec0",
  null
  
)

export default component.exports